import axios from '@/axios.js'

const state = () => ({
    barangs: []
})

const mutations = {
    SET_BARANGS (state, payload) {
      state.barangs = payload
    },
    SET_NULL (state) {
      state.barangs = []
    },
    ADD_BARANG (state, item) {
      state.barangs.unshift(item)
    },
    UPDATE_BARANG (state, barang) {
      const barangIndex = state.barangs.findIndex((p) => p.id === barang.id)
      Object.assign(state.barangs[barangIndex], barang)
    },
    REMOVE_BARANG (state, itemId) {
      const ItemIndex = state.barangs.findIndex((p) => p.id === itemId)
      state.barangs.splice(ItemIndex, 1)
    },
}

const actions = {
  fetchBarang ({ commit }, barang) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list-sort/${barang}/ASC`)
        .then((response) => {
          commit('SET_BARANGS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addBarang ({ commit }, barang ) {
    return new Promise((resolve, reject) => {
      axios.post('/term-add', barang)
        .then((response) => {
          commit('ADD_BARANG', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateBarang ({ commit }, barang) {
    return new Promise((resolve, reject) => {
      axios.post(`/term-update/${barang.id}`, barang)
        .then((response) => {
            commit('UPDATE_BARANG', response.data.data)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeBarang ({ commit }, barang) {
    return new Promise((resolve, reject) => {
      axios.delete(`/term-delete/${barang.id}`)
        .then((response) => {
            commit('REMOVE_BARANG', barang.id)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}